/**
 * Copy de precio DualCTA: precio full + descuento primer mes (admin → landing).
 *
 * ## DataFast / Stripe MRR
 * Estos montos son **suscripción mensual (MRR)**, no one-time:
 * - `fullPriceUsd` = list price /mo → Stripe Price recurrente (Exclusive Member price_1TtZs…, todas variants)
 * - `firstMonthPriceUsd` / promo_1Txbe… = 50% 1er mes **encima** del Price (no cambia el MRR base)
 * - Checkout real: DualCTA → `startVipMembershipVideoCheckout` → `/api/create-subscription-checkout`
 *   (mode=subscription + discounts[0][promotion_code] + metadata datafast_*).
 * - MuxVideoPlayerWithCTA: si el parent pasa `onCTAClick` (DualCTA), el VIP es MRR vía parent;
 *   `create-payment-intent` en Mux es packs one-time (no Dual CTA VIP).
 *
 * @see https://datafa.st/docs/stripe-checkout-api
 */

export function formatUsdAmount(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatCurrencyAmount(amount: number, currency: string): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function firstMonthPriceUsd(fullUsd: number, discountPercent: number): number {
  const pct = Math.min(100, Math.max(0, discountPercent));
  return Math.round(fullUsd * (1 - pct / 100) * 100) / 100;
}

/** Ej: "~~$9.99~~ $4.99 first month" */
export function formatDualCtaFirstMonthOffer(
  fullPriceUsd: number,
  discountPercent: number,
): { full: string; firstMonth: string; line: string; shortLine: string } {
  const full = formatCurrencyAmount(fullPriceUsd, "USD");
  const first = formatCurrencyAmount(firstMonthPriceUsd(fullPriceUsd, discountPercent), "USD");
  return {
    full,
    firstMonth: first,
    line: `${full}/mo → ${first} first month (${discountPercent}% off)`,
    shortLine: `${first} first month · then ${full}/mo`,
  };
}

export function formatAmountFromCents(
  amountCents: number,
  currency: string,
): string {
  return formatCurrencyAmount(amountCents / 100, currency);
}

export function formatCouponHint(discountPercent: number): string {
  const n = Math.round(discountPercent);
  return `PROMO${n}_1M (Stripe, 1 mes)`;
}